import NodeDetail from './NodeDetail';

// Entities are pipeline nodes, so they share the model detail screen. The route they were
// reached by is what distinguishes them; the page itself is identical.
export default function EntityDetail() {
  return <NodeDetail />;
}
